<script setup lang="ts">
useHead({
  title: "SIBangkom | Lembaga Administrasi Negara",
  meta: [
    {
      name: "description",
      content:
        "Temukan informasi mengenai Layanan Sistem Pengembangan Kompetensi ASN melalui Sibangkom, untuk meningkatkan keterampilan dan kapabilitas Aparatur Sipil Negara.",
    },
    {
      property: "og:title",
      content: "SiBangkom | Lembaga Administrasi Negara",
    },
    {
      property: "og:description",
      content:
        "SiBangkom menyediakan layanan untuk pengembangan kompetensi ASN demi pelayanan publik yang lebih baik.",
    },
    { property: "og:image", content: "./images/favicon.png" },
    { name: "twitter:card", content: "summary" },
  ],
  link: [{ rel: "icon", type: "image/png", href: "./images/favicon.png" }],
  bodyAttrs: {
    class: "sibangkom-lan",
  },
});
import SnackbarRevamp from "@/components/revamp/Snackbar.vue";
import Snackbar from "@/components/Snackbar.vue";
import { useAuthStore } from "@/stores/auth";
</script>
<template>
  <SnackbarRevamp v-if="useAuthStore().isRevamp" />
  <Snackbar v-else />
  <NuxtPwaManifest />
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
